import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routes } from './app-routing.module';
import { APP_BASE_HREF } from '@angular/common';
import { AppComponent } from './app.component';
import { CfetScreensModule } from './cfet-screens/cfet-screens.module';
import {
  AbsNavModule, BcNavModule, AbsFormsModule, AbsFooterModule,
  AbsMessagesModule, AbsModalsAndAlertsModule
} from '@att-ebiz/abs-components-bc';
import { AdobeAnalyticsService } from './cfet-core';
import { CfetSharedModule } from './cfet-shared/cfet-shared.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SessionInterceptor } from './services/session.interceptor';
import { CfetNavModule } from './cfet-nav/cfet-nav.module';
import { CfetFooterComponent } from './cfet-footer/cfet-footer.component';
import { CfetLandingComponent } from './cfet-landing/cfet-landing.component';
import { CfetCarouselComponent } from './cfet-landing/cfet-carousel/cfet-carousel.component';
import { BadCodeModalComponent } from './cfet-landing/bad-code-modal/bad-code-modal.component';
import { AuthGuardService } from './services/auth-guard.service';
import { UtfLandingComponent } from './cfet-landing/utf-landing/utf-landing.component';
import { UtfLandingNewComponent } from './cfet-landing//utf-landing/utf-landing-new/utf-landing-new.component';
import { ArkoseInterceptor } from './services/arkose.interceptor';
import { ArkoseService } from './services/arkose.service';
import { CfetPageComponentsModule } from './cfet-page-components/cfet-page-components.module';
@NgModule({
  declarations: [
    AppComponent,
    CfetFooterComponent,
    CfetLandingComponent,
    CfetCarouselComponent,
    BadCodeModalComponent,
    UtfLandingComponent,
    UtfLandingNewComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CarouselModule,
    CfetScreensModule,
    CfetNavModule,
    AbsNavModule,
    BcNavModule,
    AbsFormsModule,
    AbsFooterModule,
    AbsMessagesModule,
    CfetPageComponentsModule,
    AbsModalsAndAlertsModule,
    RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload'
  }),
    CfetSharedModule,
    ReactiveFormsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ArkoseInterceptor,
      multi: true
    },
    AdobeAnalyticsService,
    Title,
    AuthGuardService,
    ArkoseService,
    { provide: APP_BASE_HREF, useValue: window['_app_base'] || '/' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
